// src/slices/product/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// Get All Products
export const getAllProducts = createAsyncThunk("product/getAll", async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/product/all`);


    return response.data;
  } catch (err) {

    return rejectWithValue(err.response?.data);
  }
});
export const getOneProduct = createAsyncThunk("product/getOne", async (identifier, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/product/one`, { params: { identifier } });


    return response.data;
  } catch (err) {

    return rejectWithValue(err.response?.data || "Error fetching product");
  }
});

export const createProduct = createAsyncThunk("product/create", async (data, { rejectWithValue }) => {
  try {
    const payload = { ...data };

    delete payload.file;
    delete payload.files;

    const authUser = JSON.parse(sessionStorage.getItem("authUser"));
    const token = authUser?.data?.token?.replace("Bearer ", "");

    const response = await axios.post(`${API_URL}/product-store/from-user`, payload, { headers: { token, "Content-Type": "application/json" } });

    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || "Error creating product");
  }
});
